/**
 * Golfreis Jubileum – prijscalculator + formulier logica
 */
(function () {
  var BASE_PRICE = 1369;

  function formatPrice(num) {
    return num.toLocaleString('nl-NL');
  }

  /* ===== PROEFCALCULATIE (bovenaan) ===== */
  function calcPrice(alleen, panorama, partnerNiet) {
    var total = BASE_PRICE;
    if (alleen) total += 100;
    if (panorama) total += alleen ? 200 : 100;
    if (partnerNiet) total -= 300;
    return total;
  }

  function initProefCalculator() {
    var eenp = document.querySelector('[data-calc-optie="eenpersoons"]');
    var pano = document.querySelector('[data-calc-optie="panorama"]');
    var pniet = document.querySelector('[data-calc-optie="partner-niet"]');
    var totaalEl = document.getElementById('golfreis-totaal');
    var panoBedragEl = document.getElementById('panorama-bedrag');
    var pnietLabel = pniet ? pniet.closest('.golfreis__optie') : null;

    function update() {
      var alleen = eenp && eenp.checked;
      var panorama = pano && pano.checked;

      // Partner optie uitschakelen bij eenpersoonskamer
      if (pniet) {
        if (alleen) {
          pniet.checked = false;
          pniet.disabled = true;
          if (pnietLabel) pnietLabel.style.opacity = '0.4';
        } else {
          pniet.disabled = false;
          if (pnietLabel) pnietLabel.style.opacity = '';
        }
      }

      var partnerNiet = pniet && pniet.checked;
      if (panoBedragEl) panoBedragEl.textContent = alleen ? '200' : '100';
      if (totaalEl) totaalEl.textContent = formatPrice(calcPrice(alleen, panorama, partnerNiet));
    }

    [eenp, pano, pniet].forEach(function (cb) {
      if (cb) cb.addEventListener('change', update);
    });
    update();
  }

  /* ===== FORMULIER TOTAAL (onderaan) ===== */
  function isFormAlleen() {
    var root = document.querySelector('.golfreis[data-section-id]');
    if (!root) return false;
    var sectionId = root.getAttribute('data-section-id');
    var kamerAlleen = root.querySelector('#kamer_alleen_' + sectionId);
    return kamerAlleen && kamerAlleen.checked;
  }

  function calcFormBreakdown() {
    var root = document.querySelector('.golfreis[data-section-id]');
    if (!root) return { total: BASE_PRICE, persons: 1 };

    var alleen = isFormAlleen();
    var partnerWel = root.querySelector('[data-golfreis-optie="partner-wel"]');
    var partnerNiet = root.querySelector('[data-golfreis-optie="partner-niet"]');
    var panorama = root.querySelector('[data-golfreis-optie="panorama"]');
    var panoChecked = panorama && panorama.checked;
    var welChecked = partnerWel && partnerWel.checked;
    var nietChecked = partnerNiet && partnerNiet.checked;

    // Eenpersoonskamer: prijs voor 1 persoon
    if (alleen) {
      var solo = BASE_PRICE + 100; // eenpersoonstoeslag
      if (panoChecked) solo += 200; // panorama kamertoeslag
      return { total: solo, persons: 1 };
    }

    // Gedeelde kamer: optellen per persoon
    var hasPartner = welChecked || nietChecked;
    var total;
    if (welChecked) {
      total = BASE_PRICE * 2; // beide golfen
    } else if (nietChecked) {
      total = BASE_PRICE + (BASE_PRICE - 300); // partner -€300 korting (niet-golfer)
    } else {
      total = BASE_PRICE; // nog geen partner-keuze: alleen inschrijver
    }
    if (panoChecked) total += 200; // panorama kamertoeslag (eenmalig per kamer)

    return { total: total, persons: hasPartner ? 2 : 1 };
  }

  function updateFormTotal() {
    var info = calcFormBreakdown();
    var el = document.getElementById('golfreis-totaal-form');
    var labelEl = document.getElementById('golfreis-totaal-form-label');
    if (el) el.textContent = formatPrice(info.total);
    if (labelEl) {
      labelEl.textContent = info.persons === 2
        ? 'Totaalprijs voor 2 personen:'
        : 'Uw totaalprijs:';
    }
  }

  /* ===== KAMER & PARTNER LOGICA ===== */
  function initKamerPartnerLogic() {
    var root = document.querySelector('.golfreis[data-section-id]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');

    var kamerAlleen = root.querySelector('#kamer_alleen_' + sectionId);
    var kamerSamen = root.querySelector('#kamer_samen_' + sectionId);
    var samenVelden = root.querySelector('#samen-velden-' + sectionId);
    var kamerDelenInput = root.querySelector('#kamer_delen_' + sectionId);
    var partnerGolftWel = root.querySelector('#partner_golft_wel_' + sectionId);
    var partnerGolftNiet = root.querySelector('#partner_golft_niet_' + sectionId);
    var partnerVelden = root.querySelector('#partner-velden-' + sectionId);
    var panorama = root.querySelector('[data-golfreis-optie="panorama"]');

    function setPartnerFieldsRequired(show) {
      if (!partnerVelden) return;
      var inputs = partnerVelden.querySelectorAll('input[type="text"]');
      inputs.forEach(function (input) {
        if (show) {
          input.setAttribute('required', '');
        } else {
          input.removeAttribute('required');
          input.value = '';
        }
      });
    }

    function updateKamerKeuze() {
      var isSamen = kamerSamen && kamerSamen.checked;
      if (samenVelden) samenVelden.hidden = !isSamen;

      if (kamerDelenInput) {
        if (isSamen) {
          kamerDelenInput.setAttribute('required', '');
        } else {
          kamerDelenInput.removeAttribute('required');
          kamerDelenInput.value = '';
        }
      }

      if (partnerGolftNiet) {
        if (isSamen) {
          partnerGolftNiet.setAttribute('required', '');
        } else {
          partnerGolftNiet.removeAttribute('required');
          partnerGolftNiet.checked = false;
        }
      }
      if (partnerGolftWel) {
        if (!isSamen) partnerGolftWel.checked = false;
      }

      if (!isSamen) {
        if (partnerVelden) partnerVelden.hidden = true;
        setPartnerFieldsRequired(false);
      }

      updateFormTotal();
    }

    function updatePartnerGolf() {
      var welChecked = partnerGolftWel && partnerGolftWel.checked;
      if (partnerVelden) partnerVelden.hidden = !welChecked;
      setPartnerFieldsRequired(welChecked);
      updateFormTotal();
    }

    if (kamerAlleen) kamerAlleen.addEventListener('change', updateKamerKeuze);
    if (kamerSamen) kamerSamen.addEventListener('change', updateKamerKeuze);
    if (partnerGolftWel) partnerGolftWel.addEventListener('change', updatePartnerGolf);
    if (partnerGolftNiet) partnerGolftNiet.addEventListener('change', updatePartnerGolf);
    if (panorama) panorama.addEventListener('change', updateFormTotal);

    updateKamerKeuze();
  }

  /* ===== LIGHTBOX ===== */
  function initLightbox() {
    var lightbox = document.getElementById('golfreis-lightbox');
    var lightboxImg = document.getElementById('golfreis-lightbox-img');
    var closeBtn = lightbox ? lightbox.querySelector('.golfreis__lightbox-close') : null;
    if (!lightbox || !lightboxImg) return;

    var items = document.querySelectorAll('.golfreis__gallery-item');
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var img = item.querySelector('img');
        if (!img) return;
        lightboxImg.src = img.src;
        lightboxImg.alt = img.alt;
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lightboxImg.src = '';
    }

    lightbox.addEventListener('click', closeLightbox);
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
  }

  /* ===== FORM SUBMIT / SUCCESS ===== */
  function initFormSubmit() {
    var root = document.querySelector('.golfreis[data-section-id]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var form = root.querySelector('#golfreis-form-' + sectionId);
    var successEl = root.querySelector('#golfreis-success-' + sectionId);
    if (!successEl) return;

    if (window.location.search.indexOf('success=true') !== -1) {
      if (form) form.style.display = 'none';
      if (form) {
        var vragenText = form.nextElementSibling;
        if (vragenText && vragenText.tagName === 'P') {
          vragenText.style.display = 'none';
        }
      }
      var heading = root.querySelector('#heading-inschrijven');
      if (heading) heading.style.display = 'none';
      successEl.style.display = '';
      setTimeout(function () {
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    }
  }

  /* ===== INIT ===== */
  function init() {
    initProefCalculator();
    initKamerPartnerLogic();
    initLightbox();
    initFormSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
